export default __webpack_public_path__ + "static/media/Aberration.f9592c94.png";